"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsperaCheck = void 0;
/* eslint-disable @typescript-eslint/no-var-requires */
/* Package Imports */
var connect_sdk_js_1 = require("@ibm-aspera/connect-sdk-js");
var react_1 = require("react");
var react_device_detect_1 = require("react-device-detect");
var react_redux_1 = require("react-redux");
/* Blast Imports */
var constants_1 = require("@app/shared/constants");
var log_1 = __importDefault(require("@app/shared/log"));
/**
 * Tries to launch Aspera Connect before logging into Blast
 * Doesn't make any Aspera calls besides init and stop
 */
var AsperaCheck = /** @class */ (function (_super) {
    __extends(AsperaCheck, _super);
    function AsperaCheck() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AsperaCheck.prototype.componentDidMount = function () {
        var _this = this;
        this.asperaWeb = new connect_sdk_js_1.Connect({ sdkLocation: constants_1.ASPERA_SDK_LOCATION, dragDropEnabled: true, minVersion: '3.9.0' });
        this.asperaInstaller = new connect_sdk_js_1.ConnectInstaller({ sdkLocation: constants_1.ASPERA_SDK_LOCATION, iframeId: 'asperaIframe' });
        this.asperaInstaller.supportsInstallingExtensions = true;
        this.asperaWeb.addEventListener(connect_sdk_js_1.Connect.EVENT.STATUS, function (eventType, data) {
            log_1.default.debug("LOGIN PAGE ASPERA CHECK - ASPERA CONNECT STATUS: " + data);
            if (eventType === connect_sdk_js_1.Connect.EVENT.STATUS && data === connect_sdk_js_1.Connect.STATUS.RUNNING) {
                _this.asperaWeb.stop();
            }
            if (eventType === connect_sdk_js_1.Connect.EVENT.STATUS && data === connect_sdk_js_1.Connect.STATUS.EXTENSION_INSTALL) {
                setTimeout(function () {
                    _this.asperaWeb.stop();
                }, 5500);
            }
        });
        if (!react_device_detect_1.isMobile && this.props.isInitializing) {
            this.asperaWeb.initSession();
        }
    };
    AsperaCheck.prototype.render = function () {
        return null;
    };
    AsperaCheck.prototype.componentWillUnmount = function () {
        try {
            if (!react_device_detect_1.isMobile && this.props.isInitializing) {
                log_1.default.debug('Unmounting login check');
                if (this.asperaWeb) {
                    this.asperaWeb.removeEventListener(connect_sdk_js_1.Connect.EVENT.STATUS);
                    this.asperaWeb.stop();
                }
                if (this.asperaInstaller) {
                    this.asperaInstaller.dismiss();
                }
            }
        }
        catch (error) {
            log_1.default.error("Error unmounting aspera check: " + error);
        }
    };
    return AsperaCheck;
}(react_1.Component));
exports.AsperaCheck = AsperaCheck;
exports.default = react_redux_1.connect(null, null)(AsperaCheck);
